var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 500,
    viewBox: "0 0 512 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256 0C114.56 0 0 114.56 0 256C0 369.28 73.28 464.96 175.04 498.88C187.84 501.12 192.64 493.44 192.64 486.72C192.64 480.64 192.32 460.48 192.32 439.04C128 450.88 111.36 423.36 106.24 408.96C103.36 401.6 90.88 378.88 80 372.8C71.04 368 58.24 356.16 79.68 355.84C99.84 355.52 114.24 374.4 119.04 382.08C142.08 420.8 178.88 409.92 193.6 403.2C195.84 386.56 202.56 375.36 209.92 368.96C152.96 362.56 93.44 340.48 93.44 242.56C93.44 214.72 103.36 191.68 119.68 173.76C117.12 167.36 108.16 141.12 122.24 105.92C122.24 105.92 143.68 99.2 192.64 132.16C213.12 126.4 234.88 123.52 256.64 123.52C278.4 123.52 300.16 126.4 320.64 132.16C369.6 98.88 391.04 105.92 391.04 105.92C405.12 141.12 396.16 167.36 393.6 173.76C409.92 191.68 419.84 214.4 419.84 242.56C419.84 340.8 360 362.56 303.04 368.96C312.32 376.96 320.32 392.32 320.32 416.32C320.32 450.56 320 478.08 320 486.72C320 493.44 324.8 501.44 337.6 498.88C388.421 481.723 432.582 449.062 463.867 405.492C495.152 361.922 511.986 309.638 512 256C512 114.56 397.44 0 256 0Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.5f22007b87861024be1f1c5fe731c035.svg";
export { ForwardRef as ReactComponent };